import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css'
import Home from './pages/home/home';
import FormComponent from './pages/form/FormComponent';
import ImageUploader from './pages/form/MultiImageUpload';
import Navbar from './components/specific/navbar/navbar';
import LoginForm from './pages/form/login_form';
function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />  {/* Navbar component here */}

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/add-review" element={<FormComponent />} />
            <Route path="/admin/add-photos" element={<ImageUploader />} />
            <Route path="/admin/login" element={<LoginForm />} />
          </Routes>
        </div>
       
      </div>
    </Router>
  );
}

export default App;
